import Swiper from 'swiper/bundle';

let swiperBlog = null;

const initSwiper = () => {
  return new Swiper(".blog-articles-home-container__list.swiper", {
    navigation: {
      nextEl: ".blog-articles-home-container__nav-btn-next.swiper-button-next",
      prevEl: ".blog-articles-home-container__nav-btn-prev.swiper-button-prev",
    },
  });
}

const handleResize = () => {
  if (window.innerWidth <= 768) {
    if (!swiperBlog) {
      swiperBlog = initSwiper();
    } else {
      swiperBlog.update();
    }
  } else if (swiperBlog) {
    swiperBlog.destroy(true, true);
    swiperBlog = null;
  }
}

const initHomeBlogSwiper = () => {
  if(document.querySelector('.blog-articles-home-container__list.swiper')) {
    handleResize();
    window.addEventListener('resize', handleResize);
  }
}

export default initHomeBlogSwiper;
